import React from 'react';
import { FormattedMessage } from 'react-intl';
import Multiselect from '@rio-cloud/rio-uikit/Multiselect';

interface MultiselectFieldProps {
    labelId: string;
    options: string[];
    value?: string[];
    onChange: (value: string[]) => void;
}

const MultiselectOTA: React.FC<MultiselectFieldProps> = ({
    labelId,
    options,
    value = [],
    onChange,
}) => {
    const multiselectOptions = options.map(option => ({
        id: option,
        label: option,
        selected: Array.isArray(value) ? value.includes(option) : false
    }));

    const handleChange = (response: any) => {
        if (!response || !Array.isArray(response) || response.length === 0) {
            onChange(undefined);
            return;
        }
        const selectedIds = response.map((item: any) => item);
        onChange(selectedIds);
    };
    return (
        <div className='form-group'>
            <label className='control-label'>
                <FormattedMessage id={labelId}/>
            </label>
            <Multiselect
                options={multiselectOptions}
                onChange={handleChange}
                useFilter
                placeholder='Please select'
            />
        </div>
    );
};

export default MultiselectOTA;
